import React, { CSSProperties } from 'react';
import './LoadingIndicator.scoped.scss';

interface LoadingIndicatorProps {
  style?: CSSProperties;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ style }) => {
  return (
    <div className="container" style={style}>
      <div className="loading-indicator">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default LoadingIndicator;
